'use strict';
 /**
 * @author Maxim Seredkin
 */
import angular from "angular";
import MaintenanceKindsController from "./controller/maintenanceKinds";
import MaintenanceKindModalCreateController from "./controller/maintenanceKindModalCreate";
import MaintenanceKindModalSelectController from "./controller/maintenanceKindModalSelect";
import MaintenanceKindTableDirective from "./directive/maintenanceKindTable";
import MaintenanceKindService from "./service/maintenanceKind";

export default angular.module('investmentProject.maintenanceKind', [])
    .controller('MaintenanceKindsController', MaintenanceKindsController)
    .controller('MaintenanceKindModalSelectController', MaintenanceKindModalSelectController)
    .controller('MaintenanceKindModalCreateController', MaintenanceKindModalCreateController)
    .directive('maintenanceKindTable', MaintenanceKindTableDirective)
    .factory('MaintenanceKindService', MaintenanceKindService)
    .name;
